import { App, Space, Tooltip } from "antd";
import { TableUi } from "../../ui";
import { EditDetailBtn, RemoveDetailBtn } from "../../ui/Buttons";
import { useDispatch } from "react-redux";
import {
  periodoContableSetActive,
  periodoContableStartDelete,
} from "../../../actions";
import { ShowDeleteConfirm } from "../../../helpers";
const columns = (acciones) => {
  const { handleEditar, handleRemover } = acciones;
  return [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (text, record, i) => <>{i + 1}</>,
    },
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
    },
    {
      title: "Fecha inicio",
      dataIndex: "fechainicio",
      key: "fechainicio",
    },
    {
      title: "Estado",
      dataIndex: "estado",
      key: "estado",
    },
    {
      title: "Acciones",
      dataIndex: "acciones",
      key: "acciones",
      render: (value, record) => (
        <>
          <Space size="middle">
            <Tooltip title="Editar">
              <EditDetailBtn
                showText={false}
                onClick={() => handleEditar(record)}
              />
            </Tooltip>
            <Tooltip title="Eliminar">
              <RemoveDetailBtn
                showText={false}
                onClick={() => handleRemover(record)}
              />
            </Tooltip>
          </Space>
        </>
      ),
    },
  ];
};
export const PeriodoContableTable = ({ data, loading, handleOpenModal }) => {
  const dispatch = useDispatch();
  const { modal } = App.useApp();
  const handleEditar = (record) => {
    dispatch(periodoContableSetActive(record));
    handleOpenModal();
  };
  const handleRemover = (record) => {
    ShowDeleteConfirm({
      modal,
      title: "¿Está seguro de eliminar el periodo contable seleccionado?",
      content: record.nombre,
      callback: (isConfirmed) => {
        if (isConfirmed) {
          dispatch(periodoContableStartDelete(record));
        }
      },
    });
  };
  return (
    <TableUi
      size="small"
      columns={columns({
        handleEditar,
        handleRemover,
      })}
      data={data}
      rowKey="id"
      loading={loading}
    />
  );
};
